<script lang="ts">
  /**
   * Math — LaTeX expression renderer via KaTeX.
   *
   * Thin Svelte wrapper around `katex.renderToString`. Content is injected
   * with {@html} because KaTeX emits HTML markup, not text. Errors are
   * swallowed and rendered inline in red so broken TeX is visible but
   * doesn't crash the page (matches KaTeX's default `throwOnError: false`).
   *
   * The global KaTeX stylesheet is imported once from app.css.
   */
  import katex from 'katex';

  type Props = {
    tex: string;
    /** When true, render in display style (larger, centered). */
    displayMode?: boolean;
  };

  let { tex, displayMode = false }: Props = $props();

  const html = $derived(
    katex.renderToString(tex, {
      displayMode,
      throwOnError: false,
      output: 'html',
      strict: 'ignore',
    })
  );
</script>

{#if displayMode}
  <div class="math-block">{@html html}</div>
{:else}
  <span class="math-inline">{@html html}</span>
{/if}

<style>
  .math-block {
    display: flex;
    justify-content: center;
    padding: var(--space-sm) 0;
  }

  .math-inline :global(.katex),
  .math-block :global(.katex) {
    color: var(--ink);
  }

  .math-inline :global(.katex-error),
  .math-block :global(.katex-error) {
    color: #dc3545;
    font-family: var(--font-mono);
    font-size: 0.9em;
  }
</style>
